import { createSelector } from '@reduxjs/toolkit';
import { IApplicationState } from 'shared/mortgageMiniCalculator/types/redux';

export const selectSaveOffersError = createSelector(
  [(state: IApplicationState) => state.calculator.isErrorGetOffersListing],
  saveOffersError => saveOffersError,
);
